export const WORKSHEET_ID = 'WORKSHEET';

export const worksheetActionTypes = {
  ON_INCORRECT_START: 'ON_INCORRECT_START',
  ON_INCORRECT_END: 'ON_INCORRECT_END',
  ON_CORRECT_START: 'ON_CORRECT_START',
  ON_CORRECT_END: 'ON_CORRECT_END',
  SET_WORKSHEET_DETAILS: 'SET_WORKSHEET_DETAILS',
  INIT_WORKSHEET: 'INIT_WORKSHEET',
  SET_VISIBLE: 'SET_VISIBLE',
  SET_IS_AVAILABLE: 'SET_IS_AVAILABLE',
};

export const feedbackTypes = {
  NONE: 'NONE',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
};

export const DISABLED_OPACITY = 0.4;
